<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row" v-if="type === 'main'">
                <div class="topTabsActionButtons"
                     :class="buttonsConfig.length > 0 ? 'col-md-'+left : `col-md-12`"
                     style="visibility:visible">
                    <div id="tabSet" class="scroll_tabs_theme_light scroll_tabs_container">
                        <div class="scroll_tab_left_button scroll_tab_buttons"></div>
                        <div class="scroll_tab_inner">
                            <span class="scroll_tab_left_finisher scroll_tab_buttons">&nbsp;</span>
                            <ul :class=getParentClass() v-if="tabsToRender.length > 0">
                                <template v-for="(tab, tab_index) in tabsToRender" :key="tab_index">
                                <router-link
                                        v-if="!!tab.display"
                                        :to="routerPath(tab)"
                                        custom
                                        v-slot="{ href, navigate, isActive, isExactActive }">
                                    <li :data-tab-id=tab.tab_id
                                        role="link"
                                        :active-class="'active tab_selected'"
                                        :class="[isActive && 'router-link-active active tab_selected',
                                            isExactActive && 'active tab_selected router-link-exact-active']"
                                        @click="navigate"
                                        @keypress.enter="navigate"
                                        >
                                    <a :title="tab.title" :href="tab.url_router" relative><i :class=tab.icon></i>{{getLabel(tab)}}</a>
                                    </li>
                                </router-link>
                                </template>
                            </ul>
                            <span class="scroll_tab_right_finisher scroll_tab_buttons">&nbsp;</span>
                        </div>
                        <div class="scroll_tab_right_button scroll_tab_right_button"></div>
                    </div>
                </div>
                <div class="topTabsActionButtons col-12" :class="'col-md-'+right" v-if="buttonsConfig.length > 0">
                    <np-buttons
                            :buttons-config="buttonsConfig"
                            @buttonclick="handleButtonClick"
                    ></np-buttons>
                </div>
                <div id="subTabSet"
                     v-for="(tab, tab_index) in tabsToRender"
                     class="col-md-12 topTabsSubitemsContainer"
                     v-if="!!tab.subitems && tab.subitems.length > 0 && tab.subitems.some(obj => {return obj.parent_url === tab.url && urlMatch(obj)})">
                    <ul class="loneTopTabsSubitems clearfix">
                        <template v-for="(sub_tab, index) in tab.subitems" :key="`${tab_index}_${index}`">
                        <router-link
                                v-if="!!sub_tab.display"
                                :to="sub_tab.url_router"
                                custom
                                v-slot="{href, navigate, isActive, isExactActive }">
                            <li :data-sub_tab-id=sub_tab.tab_id
                                role="link"
                                :class="[isActive && 'router-link-active active tab_selected',
                                        isExactActive && 'active tab_selected router-link-exact-active',
                                        {active: urlMatch(sub_tab)}]"
                                :title="sub_tab.title"
                                @click="navigate"
                                @keypress.enter="navigate"
                                >
                            <a :title="sub_tab.title" :href="sub_tab.url_router" relative>{{getLabel(sub_tab)}}</a>
                            </li>
                        </router-link>
                        </template>
                    </ul>
                </div>
            </div>
            <div class="row" v-else-if="type === 'smallify'">
                <div class="topTabsActionButtons smallify"
                     :class="buttonsConfig.length > 0 ? 'col-md-'+left : `col-md-12`"
                     style="visibility:visible">
                    <div id="tabSetSmallify"  style="border-top: 1px solid #b2c6d0" class="scroll_tabs_theme_light scroll_tabs_container">
                        <div class="scroll_tab_left_button scroll_tab_buttons"></div>

                        <div class="scroll_tab_inner">
                            <span class="scroll_tab_left_finisher">&nbsp;</span>
                            <template v-for="(tab, tab_index) in tabsToRender" :key="tab_index">
                            <ul :class=getParentClass() v-if="tabsToRender.length > 0">
                                <li :class=getMainTabClass(tab)
                                    v-on:click="handleMainClick(tab_index)"
                                    :data-tab-id=tab.tab_id
                                    v-if="!!tab.display">
                                    <router-link tag="a" :to="routerPath(tab)" :title="tab.title">
                                        <i v-if="!!tab.icon" :class=tab.icon></i>{{getLabel(tab)}}
                                    </router-link>
                                </li>
                            </ul>
                            </template>
                            <span class="scroll_tab_right_finisher scroll_tab_buttons">&nbsp;</span>
                        </div>
                        <div class="scroll_tab_right_button scroll_tab_buttons"></div>
                    </div>
                </div>
                <div class="topTabsActionButtons smallify col-12" :class="'col-md-'+right"
                     v-if="buttonsConfig.length > 0">
                    <np-buttons
                            :small="true"
                            :buttons-config="buttonsConfig"
                            @buttonclick="handleButtonClick"
                    ></np-buttons>
                </div>
                <div id="subTabSetSmallify"
                     class="col-md-12 topTabsSubitemsContainer"
                     v-if="!!activeMain && !!activeMain.subitems && activeMain.subitems.length > 0 && !!activeMain.display">
                    <ul class="loneTopTabsSubitems clearfix">
                        <template v-for="(sub_tab, index) in activeMain.subitems">
                        <li :class={active:!!sub_tab.is_active}
                            v-on:click="handleSubClick(index, activeMainIndex)"
                            :data-sub_tab-id=sub_tab.tab_id
                            v-if="!!sub_tab.display">
                            <a :href=getUrl(sub_tab) :title="sub_tab.title">{{getLabel(sub_tab)}}</a>
                        </li>
                        </template>
                    </ul>
                </div>
            </div>
            <div v-else class="row">
                <div id="subTabSetOnly"
                     class="col-md-12 topTabsSubitemsContainer" v-if="tabsToRender.length > 0">
                    <ul class="loneTopTabsSubitems clearfix">
<template v-for="(tab, tab_index) in tabsToRender" :key="tab_index">
                        <router-link
                            :to="routerPath(tab)" custom
                            v-slot="{ navigate, isActive, isExactActive }">
                                <li :data-tab-id=tab.tab_id
                                    role="link"
                                    :class="[isActive && 'router-link-active active tab_selected',
                                    isExactActive && 'active tab_selected router-link-exact-active']"
                                    @click="navigate" @keypress.enter="navigate">
                            <a :title="tab.title" :href="tab.url_router" relative>{{getLabel(tab)}}</a>
                                </li>
                        </router-link>
</template>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import NPButtons from './np-buttons.vue';
    import VueRouter from 'vue-router';

    export default {
        name: 'np-router-toptabs',
        props: {
          show_scroll_after: {
            type: Number,
            note: 'number of button to show scroll',
            default:2
          },

          tabsConfig: {
                type: Array,
                note: 'List of tabs that will be rendered'
            },
            buttonsConfig: {
                type: Array,
                default: () => {
                    return []
                },
                note: 'List of Buttons that will be rendered. only works when type = main'
            },
            appendUrl: {
                default: ''
            },
            addClass: {
                default: ''
            },
            currentRoute: {
                default: ''
            },
            type: {
                default: 'main' //allowed main , sub
            },
            split: {
                default: 0.6 // determines width of maintabs and buttons
            },
            vueRouter: {
                default: true,
                note: 'defines if vue-router is used on page'
            }
        },
        mounted: function () {
            if (this.type !== 'smallify') {
                $('#tabSet').scrollTabs('', true);
            } else {
                $('#tabSetSmallify').scrollTabs('', true);
            }
            $(".topTabsActionButtons").css('visibility', 'visible');
            // this.setActiveTab();
          let renderedTabs = this.tab_data.filter(f => f.display === true)
          $('.scroll_tab_buttons').css('visibility', renderedTabs.length>this.show_scroll_after?'visible':'hidden')

        },
        created: function () {
            // this.setActiveTab();
        },
        data: function () {
            return {
                level_2: false,
                tab_data: [],
            }
        },
        computed: {
            tabsToRender: function () {
                let tabs = [];
                let vm = this;
                if (this.tab_data.length > 0) {
                    this.tab_data.forEach(function (obj, index) {
                        tabs.push(new TopTab(obj))
                        // if (!!obj.subitems && obj.subitems.length > 0) {
                        //     vm.level_2 = true
                        // }
                    })
                }
                return tabs;
            },
            activeMain: function () {
                return this.tabsToRender.find(obj => {
                    return !!obj.is_active
                });
            },
            activeMainIndex: function () {
                return this.tabsToRender.findIndex(obj => {
                    return !!obj.is_active
                });
            },
            _split: function () {
                if (isNaN(this.split)) {
                    return 0.6;
                } else {
                    return this.split;
                }
            },
            left: function () {
                return Math.round(12 * this._split)
            },
            right: function () {
                return 12 - this.left;
            }
        },
        watch: {
            tabsConfig: {
                handler: function (newValue) {
                    this.tab_data = newValue;
                },
                immediate: true,
                deep: true
            }
        },
        components: {
            'np-buttons': NPButtons
        },
        methods: {
            urlMatch: function (tab) {
                return !!tab.url_router && this.currentRoute.includes(tab.url_router);
            },
            routerPath: function (tab) {
                let path= '';
                if (this.type === 'smallify'){
                    path = !!tab.url_router ? tab.url_router : '#';
                } else{
                    path = !!tab.url_router ? '/'+ tab.url_router : '#';
                }
                return {path: path}
            },
            getParentClass: function () {
                let mult = this.level_2 ? 'topTabsMultiLevel ' : '';
                let other = 'topTabsf clearfix ';
                return other + mult + this.addClass
            },
            getMainTabClass: function (tab) {
                let active_class = 'active tab_selected ';
                return !!tab.is_active ? active_class + tab.class : tab.class;
            },
            getLabel: function (tab) {
                return tab.lang_key !== '' ? this.lang(tab.lang_key) : tab.label
            },
            getUrl: function (tab) {
                let url = '#'
                if (this.vueRouter){
                    if (tab.url_router !== '') {
                        url = tab.url_router[0] === '/' ? tab.url_router : '/' + tab.url_router;
                        url = this.appendUrl === '' ? url : url + '/' + this.appendUrl;
                    }
                }

                return url;
            },
            setActiveTab: function () {
                let vm = this;
                let tabs = [];
                if (vm.tabsConfig.length > 0) {
                    vm.tabsConfig.forEach(obj_taba => {
                        let obj_tab = new TopTab(obj_taba)
                        obj_tab.is_active = vm.isActiveTab(obj_tab);
                        if (!!obj_tab.subitems && obj_tab.subitems.length > 0) {
                            let subs = [];
                            obj_tab.subitems.forEach(obj_sub => {
                                if (vm.isActiveTab(obj_sub)) {
                                    obj_sub.is_active = true;
                                    obj_tab.is_active = true;
                                }
                                subs.push(obj_sub);
                            });
                            obj_tab.subitems = subs;
                        }
                        tabs.push(obj_tab);
                    });
                    vm.tab_data = tabs;
                }
            },
            isActiveTab: function (tab) {
                let is_active =  !!tab.url_router && tab.url_router != '' && tab.url_router !== '#' && !!window.location.href.match(tab.url_router)
                return is_active;
            },
            handleMainClick: function (tab_index) {
                let vm = this;
                let sub_tab_id = ''
                let selectedTab = this.tab_data.find(function (val, index) {
                    return index === tab_index
                });
                let no_toggle = !!selectedTab && selectedTab.class == 'addOutlet';
                if (vm.tab_data.length > 0) {
                    vm.tab_data.forEach(function (value, index) {
                        if (!no_toggle) {
                            value.is_active = index === tab_index;
                        }
                        if (!!value.subitems && value.subitems.length > 0) {
                            value.subitems.forEach(function (sub_val, sub_index) {
                                if (!no_toggle) {
                                    sub_val.is_active = false;
                                }
                            });
                            if (tab_index === index) {
                                value.subitems[0].is_active = true;
                                sub_tab_id = value.subitems[0].tab_id
                            }
                        }
                    });
                    this.$emit('toptabclick', vm.tab_data[tab_index].tab_id, sub_tab_id)
                }
            },
            handleSubClick: function (sub_index, tab_index) {
                let vm = this;
                if (tab_index >= 0 && !!vm.tab_data[tab_index].subitems && vm.tab_data[tab_index].subitems.length > 0) {
                    vm.tab_data[tab_index].subitems.forEach(function (sub_val, index) {
                        sub_val.is_active = index === sub_index;
                    });
                    this.$emit('subtabclick', vm.tab_data[tab_index].subitems[sub_index].tab_id)
                }
            },
            handleButtonClick: function (button_id) {
                this.$emit('buttonclick', button_id)
            },
        },
    };

    class TopTab {
        constructor(item) {
            this.url = '';
            this.url_router = '';
            this.label = '';
            this.tab_id = '';
            this.lang_key = '';
            this.icon = '';
            this.class = '';
            this.title = '';
            this.display = true;
            this.is_active = false;
            this.subitems = [];
            if (!!item) {
                this.setItem(item);
            }
        }

        setItem(item) {
            let item_keys = Object.keys(item);
            let vm = this;
            item_keys.map(f => {
                if (f === 'subitems' && item[f].length > 0) {
                    item[f].forEach(obj => {
                        vm.subitems.push(new SubTab(obj))
                    });
                } else {
                    this[f] = item[f]
                }
            });
        }
    }

    class SubTab {
        constructor(item) {
            this.url = '';
            this.url_router = '';
            this.label = '';
            this.tab_id = '';
            this.lang_key = '';
            this.icon = '';
            this.title = '';
            this.class = '';
            this.is_active = false;
            this.display = true;
            if (!!item) {
                this.setItem(item);
            }
        }

        setItem(item) {
            let item_keys = Object.keys(item);
            item_keys.map(f => {
                this[f] = item[f]
            });
        }
    }

</script>
<style scoped>
    #subTabSetOnly {
        padding-right: 15px;
        padding-left: 15px;
    }
</style>
